import { render, staticRenderFns } from "./PrivateAddCompany.vue?vue&type=template&id=28c58374&scoped=true"
import script from "./PrivateAddCompany.vue?vue&type=script&lang=js"
export * from "./PrivateAddCompany.vue?vue&type=script&lang=js"
import style0 from "./PrivateAddCompany.vue?vue&type=style&index=0&id=28c58374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c58374",
  null
  
)

export default component.exports